import { AnswerRepository } from "../../../../data/repository/answer/AnswerRepository";
import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { Message } from "../../../model/Auth";
import { Category } from "../../../model/Category";
import { ResponseState, State } from "../../../model/ResponseState";

export interface DeleteAnswerUseCase {
  invoke: (id: string) => Promise<ResponseState<Message>>;
}

export class DeleteAnswerUseCaseImpl implements DeleteAnswerUseCase {
  private answerRepository: AnswerRepository;

  constructor(answerRepository: AnswerRepository) {
    this.answerRepository = answerRepository;
  }

  async invoke(id: string): Promise<ResponseState<Message>> {
    try {
      let response = await this.answerRepository.deleteAnswer(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
